import styled, { css } from 'styled-components';
import { FuelToast } from '@frete.com/fuel-react';
import { WIDTH_MENU_HOST } from '@constants';
import { mediasQuery } from '@utils/responsive';

export const FloatingToast = styled(FuelToast)`
  ${({ theme }) => css`
    position: fixed;
    bottom: ${theme.spacing.km10};
    left: calc(${theme.spacing.km8} + ${WIDTH_MENU_HOST});
    max-width: 470px;
    /* Adicionar z-index: 1101, porque o company_evaluating está com 1000 */
    z-index: 1101;

    ${mediasQuery.maxMdMax} {
      left: ${theme.spacing.km6};
      bottom: ${theme.spacing.km6};
      max-width: calc(100vw - ${theme.spacing.km12});
    }
  `}
`;
